/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import {  shape } from 'prop-types';
import { useSelector } from 'react-redux';
import Heading from './Heading';
import Banner from './Banner';
import Cards from './Cards';
import { getFeatureFlag } from '../../../../../../state/ducks/App/ducks/Config/Config-Selectors';
import MarketingSpotsPdPV2 from './MarketingSpotsPdPV2';

const  MarketingSpotsPDPBlocks = ({
    data, productData,
}) => {
    if (!data || !productData) return null;
    const pdpMarketingBlockEnabled = useSelector(getFeatureFlag('is-pdp-marketing-block-enabled'));
    const currentProduct = productData.partNumber.toUpperCase(); // normalize
    // Determine if product exists in one of the entries.
    const blockMatches = [];

    data.filter((match) => {
        const itemArr = match.productid_list.toUpperCase().split(/[\s*]+|(,\s*)/g); // matches spaces, commas and some comma/space combos. Not necessary to deep-clean it as everything else will be ignored regardless.
        const i = itemArr.indexOf(currentProduct);
        if (i !== -1) blockMatches.push(match);
        return null;
    });

    return (
        pdpMarketingBlockEnabled
            ?  (
                <>
                    { blockMatches?.map((items) => {
                        const  { modular_blocks = [], presentation_style = 'default' } = items || {};
                        if (presentation_style === 'default') {
                            return  modular_blocks?.map((block) => {
                                const blockKey = Object.keys(block);
                                const blockObj = block[blockKey];
                                switch (blockKey[0]) {
                                    case 'cards': return <Cards data={blockObj} />;
                                    case 'heading': return <Heading data={blockObj} />;
                                    case 'banner': return <Banner data={blockObj} />;
                                    default: return <></>;
                                }
                            });
                        }
                        return <MarketingSpotsPdPV2 blockMatch={modular_blocks} />;
                    })}
                </>
            ) : null
    );
};

MarketingSpotsPDPBlocks.propTypes = {
    data: shape({
        something: null,
    }),
    productData: shape({
        something: null,
    }),
};
MarketingSpotsPDPBlocks.defaultProps = {
    data: {},
    productData: {},
};
export default  MarketingSpotsPDPBlocks;
